import * as React from 'react';
export const OMSvg = React.forwardRef(function OMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M4 2h9.991C15.098 2 16 2.895 16 4v2H4V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 6V4a1 1 0 0 0-1-1H4V2h10a2 2 0 0 1 2 2v2h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 2h2v12H2a2 2 0 0 1-2-2.009V4.01C0 2.902.895 2 2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        fillOpacity: 0.2,
        d: 'M3 2h1v12H3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M4 6h12v4H4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M4 10h12v2a2 2 0 0 1-2.009 2H4v-4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z',
      }),
    ),
  );
});
OMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var OM = {
  category: 'flag',
  colorable: false,
  name: 'OM',
  svg: OMSvg,
};
